import axios from 'axios'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from '../components/loader/Loader'
import appConfig from '../config'
import PreCache from '../helpers/PreCache'
import Intro from '../pages/intro/Intro'
import routes from '../routes'
import { loggedIn, loggedOut } from '../slices/authSlice'
import { Layout } from '../Views'

export const PrivateRoute = () => {
  const { isAuthLoading, isAuthenticated, currentUser } = useSelector(
    (state: any) => state.auth
  )
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [skipped, setSkipped] = useState(false)

  const shouldPlayIntro = localStorage.getItem('introSkipped') !== 'true'

  const skipVid = () => {
    localStorage.setItem('introSkipped', 'true')
    setSkipped(true)
  }

  useEffect(() => {
    // if (!isAuthenticated) promptLogin();
    if (isAuthenticated) {
      axios
        .get(`${appConfig.API_URL}/auto_login`)
        .then((response) => {
          dispatch(loggedIn(response.data.user))
          // navigate(routes.chatPage);
        })
        .catch((error) => {
          dispatch(loggedOut())
        })
    } else {
      navigate(routes.root)
    }
  }, [isAuthenticated])

  if (isAuthLoading || !currentUser) return <Loader />

  return (
    <>
      {shouldPlayIntro && !skipped ? (
        <PreCache skipVid={skipVid}>
          <Intro skipVid={skipVid} />
        </PreCache>
      ) : (
        <Layout currentUser={currentUser} />
      )}
    </>
  )
}
